import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_expensetype,
  add_expensetype,
  update_expensetype,
  delete_expensetype,
  get_expensetype_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
    expensetype: [],
    expensetypelist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    description:""
  },
};

// Async Thunks for API Calls
export const fetchexpensetypelist = createAsyncThunk(
    'expensetype/fetchexpensetypelist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_expensetype_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  

// Async Thunks for API Calls
export const fetchexpensetype = createAsyncThunk(
  "expensetype/fetchexpensetype",
  async ({ page, page_size,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_expensetype(page, page_size,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createexpensetype = createAsyncThunk(
  "expensetype/createexpensetype",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_expensetype(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateexpensetype = createAsyncThunk(
  "expensetype/updateexpensetype",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_expensetype(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteexpensetype = createAsyncThunk(
  "expensetype/deleteexpensetype",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_expensetype({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// hostel_category Slice
const expensetypeSlice = createSlice({
  name: 'expensetypes',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, name,description } = action.payload;
      state.formData = { id, name,description };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        description:""
      };
    },
    setexpensetype(state, action) {
      state.expensetype = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchexpensetypelist.fulfilled, (state, action) => {
        state.expensetypelist = action.payload.data;
      })
      .addCase(fetchexpensetypelist.rejected, (state, action) => {
        state.expensetypelist = [];

      })

       // Fetch hostel_category
       .addCase(fetchexpensetype.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchexpensetype.fulfilled, (state, action) => {
        state.loading = false;
        state.expensetype = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchexpensetype.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add hostel_category
      .addCase(createexpensetype.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createexpensetype.fulfilled, (state, action) => {
        state.addLoading = false;
        state.expensetype = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createexpensetype.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update hostel_category
      .addCase(updateexpensetype.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateexpensetype.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateexpensetype.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete hostel_category
      .addCase(deleteexpensetype.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteexpensetype.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteexpensetype.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setexpensetype,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = expensetypeSlice.actions;
export default expensetypeSlice.reducer;
